import appNotificationService from '@core/services/utils/appNotificationService';
import authHeader from '@core/services/app/authHeader';
import routerService from '@core/services/app/routerService';
import AxiosService from '@core/services/app/axiosService';

class AppMenuService {

  /**
   * Load menu from backend and configure routes
   * Note: routerService is already initialized by initRouter.js boot file
   * with all remote page modules
   */
  async loadMenu() {
    return await routerService.loadMenu();
  }

  /**
   * Refresh routes after menu updates
   */
  refreshRoutes() {
    routerService.refreshRoutes();
  }

  /**
   * Create or update a menu item
   */
  async createOrUpdate(item) {
    try {
      const response = await AxiosService.post('/appMenu/createOrUpdate', { menu: item }, {
        headers: authHeader()
      });
      appNotificationService.pushInfo(response.data.message);
      return response.data.appMenu;
    } catch (error) {
      appNotificationService.pushError(error.response?.data?.message || 'Failed to save menu item');
    }
  }

  /**
   * Delete a menu item
   */
  async delete(item) {
    if (!item) return;

    try {
      const response = await AxiosService.post('/appMenu/delete', { id: item.id }, {
        headers: authHeader()
      });
      appNotificationService.pushInfo(response.data.message);
    } catch (error) {
      appNotificationService.pushError(error.response?.data?.message || 'Failed to delete menu item');
      throw error;
    }
  }
}

export default new AppMenuService();
